module.exports = __webpack_public_path__ + "img/banner-vaccine-en.bfb111de.png";